import React, {useState} from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  VStack,
  Text,
  Box,
  Flex,
  HStack,
  Badge
} from '@chakra-ui/react';
import {event} from '../../../../services/analytics';
import {CheckIcon} from "@chakra-ui/icons";

// Adjust import path as needed

interface UpgradePlanProps {
    monthlyPlanLink: string
    yearlyPlanLink: string
    // Define props if needed
}

const PlanDetailsComponent: React.FC<UpgradePlanProps> = ({monthlyPlanLink, yearlyPlanLink}) => {
  const features = [
    "Save 10,000 emails / mo",
    "Send 5000 emails / mo",
    "All features"]

  const featComponents = () => (<VStack alignItems={"start"} mt={4}>
    <Text mb={1}>Get instant access to</Text>
    {features.map((f, idx) =>
      <Flex key={idx}
        textAlign={"start"}
        alignItems={"start"}
      >
        <CheckIcon color="white" bgColor={"green.400"} mt={1} p={1} h={4} w={4} rounded={"full"} mx={1.5}/>
        <Text fontSize={"md"}>{f}</Text>
      </Flex>)
    }
  </VStack>)


  return <VStack spacing={4}>
    <Flex direction={{base: 'column', md: 'row'}} justify="center" align="center" w="full">
      <Box p={4} w={'full'} flex="1" m={2} textAlign="center" border={"1px solid black"} borderColor={"gray.200"}
        shadow={"sm"} borderRadius={"md"}>
        <Text fontSize="lg" mb={2} fontWeight={"medium"}>Monthly Premium</Text>
        <Text fontSize="xl" fontWeight="bold">$19.99 / mo</Text>

        <Button
          colorScheme="pink"
          size="sm"
          mt={4}
          className={"lemonsqueezy-button"}
          as={'a'}
          href={monthlyPlanLink}
          onClick={() => {
            event({action: "upgrade_monthly_click", params: {}});
            window.LemonSqueezy.Url.Open(monthlyPlanLink);
          }}
        >
          <span>Upgrade to Monthly</span>
        </Button>
        <HStack justifyContent={'center'} visibility={"hidden"}>
          <Text fontSize="md" as="s" color="gray.500">19.99 / yr</Text>
          <Badge colorScheme="green" mb={2}>0% Off</Badge>
        </HStack>
        {featComponents()}

      </Box>
      <Box p={4} w={'full'} flex="1" m={2} textAlign="center" border={"1px solid black"} borderColor={"gray.200"}
        shadow={"sm"} borderRadius={"md"}>
        <Text fontSize="lg" mb={2} fontWeight={"medium"}>Annual Premium</Text>
        <Text fontSize="xl" fontWeight="bold">199 / yr</Text>
        <HStack justifyContent={'center'}>
          <Text fontSize="md" as="s" color="gray.500">228 / yr</Text>
          <Badge colorScheme="green" mb={2}>15% Off</Badge>
        </HStack>

        <Button
          colorScheme="green"
          size="sm"
          mt={4}
          className={"lemonsqueezy-button"}
          as={'a'}
          href={yearlyPlanLink}
          onClick={() => {
            event({action: "upgrade_annual_click", params: {}});
            window.LemonSqueezy.Url.Open(yearlyPlanLink);
          }}
        >
          <span>Upgrade to Annual</span>
        </Button>
        {featComponents()}

      </Box>
    </Flex>
  </VStack>
};


const UpgradePlanModal: React.FC<{
    isOpen: boolean; onClose: () => void, monthlyPlanLink: string
    yearlyPlanLink: string
}> = ({isOpen, onClose, monthlyPlanLink, yearlyPlanLink}) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
    <ModalOverlay/>
    <ModalContent>
      <ModalHeader>Upgrade your account</ModalHeader>
      <ModalCloseButton/>
      <ModalBody pb={6}>
        <PlanDetailsComponent monthlyPlanLink={monthlyPlanLink} yearlyPlanLink={yearlyPlanLink}/>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} variant="ghost">
                    Cancel
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

const UpgradePlanButton: React.FC<UpgradePlanProps> = ({monthlyPlanLink, yearlyPlanLink}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    event({action: "open_upgrade_modal", params: {}});
    setIsOpen(true);
  };

  const closeModal = () => setIsOpen(false);

  return (
    <>
      <Button
        variant={"outline"} size={"sm"} colorScheme={"pink"}
        w={{base: "100%", md: "auto"}}
        onClick={openModal}
      >
                💎 Upgrade
      </Button>
      <UpgradePlanModal isOpen={isOpen} onClose={closeModal} monthlyPlanLink={monthlyPlanLink}
        yearlyPlanLink={yearlyPlanLink}/>
    </>
  );
};

export default UpgradePlanButton;
